var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 54,
    fill: "#FAF5EF",
    fillOpacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 53,
    stroke: "#363636",
    strokeOpacity: 0.2,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0246 25L60.2512 66.0571H47.3941L45.6207 25H62.0246ZM54.0443 88C51.3842 88 49.197 87.2571 47.4828 85.7714C45.8276 84.2286 45 82.3429 45 80.1143C45 77.8286 45.8276 75.9143 47.4828 74.3714C49.197 72.8286 51.3842 72.0571 54.0443 72.0571C56.6453 72.0571 58.7734 72.8286 60.4286 74.3714C62.1429 75.9143 63 77.8286 63 80.1143C63 82.3429 62.1429 84.2286 60.4286 85.7714C58.7734 87.2571 56.6453 88 54.0443 88Z",
    fill: "#E4151B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData1);
export default __webpack_public_path__ + "static/media/no-data1.97864c3e56e37e366510112dd86e6461.svg";
export { ForwardRef as ReactComponent };